module.exports = __webpack_public_path__ + "img/4.e6776468.png";